// extracted by mini-css-extract-plugin
export default {"dock":"Dock_dock__B5pIx","item":"Dock_item__wupo3","selected":"Dock_selected__meEVY","sides":"Dock_sides__5o3eP"};